import debug from 'bows';

const log = debug('breadcrumb');

class Breadcrumb {
	constructor(node) {
		this.node = node;
		this.open = false;
		this.toggler = this.node.querySelector('.breadcrumb__list-toggle');
		this.submenu = this.node.querySelector('.breadcrumb__list--depth1');

		if (this.toggler && this.submenu) {
			let toggle = () => {
				if (this.open) {
					this.toggler.classList.remove('breadcrumb__list-toggle--active');
					this.submenu.classList.remove('breadcrumb__list--active');
					this.open = false;
				} else {
					this.toggler.classList.add('breadcrumb__list-toggle--active');
					this.submenu.classList.add('breadcrumb__list--active');
					this.open = true;
				}
			};

			// Toggle on click
			this.toggler.addEventListener('click', toggle);

			// Toggle closed on document click
			document.addEventListener('click', (e) => {
				// Ignore clicks if breadcrumbs is not open
				if (!this.open) {
					return;
				}

				// Traverse DOM to find either the top level, or one of our elements
				let target = e.target;
				while (target !== this.toggler && target !== this.submenu && target.parentNode) {
					target = target.parentNode;
				}
				// Toggle if not within one of our elements
				if (target !== this.toggler && target !== this.submenu) {
					toggle();
				}
			});

		}
	}
}

export default Breadcrumb;
